import { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

export type DividerProps = {
  className?: string
  vertical?: boolean
} & HTMLAttributes<HTMLHRElement>

export const Divider = ({ className, vertical = false, ...props }: DividerProps) => (
  <hr
    {...props}
    className={cn(
      "m-0 flex-shrink-0 border-none bg-grey-300",
      vertical ? "h-auto min-h-full w-px" : "h-px",
      className,
    )}
  />
)
